import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";

/**
 * An array of data with an associated page object used for paging
 */
export class ListaPaginataVO<T> {
  data = new Array<T>();
  page = new PaginazioneVO();
}
